/* eslint-disable no-useless-escape */
import _ from 'underscore';

export const maxKeywordLength = 100;
export const maxKeywords = 1000;

export const peekKeywords = ({ keywordsTextarealVal, isNegativeKeyword = false, activity }) => {
  let newKeywords = keywordsTextarealVal;
  if (!_.isString(newKeywords) || _.isEmpty(newKeywords) || _.isEmpty(newKeywords.replace(/[,\s]+/, ''))) {
    return [];
  }
  const splitChar = ',';

  // Trim white space and commas from the beginning and end of the input string
  newKeywords = newKeywords.replace(/((^[,\s]+)|([,\s]+$))/g, '');
  // Trim extra whitespace and commas from before and after each keyword
  if (isNegativeKeyword) {
    // keywords with commas should not be split into multiple keywords
    newKeywords = newKeywords.replace(',', '%2C');
  } else if (newKeywords.indexOf(',') >= 0 && activity) {
    activity.signal(`User has comma in keywords input - ${JSON.stringify({
      KeywordsInput: newKeywords,
    })}`);
  }
  newKeywords = newKeywords.replace(/([,\s]*[\n\r\,]+[,\s]*)/g, splitChar);
  // Remove extra spaces at the beginning or end of match type brackets
  newKeywords = newKeywords.replace(/[\t ]+(?=\]|\)|\")/g, '');
  newKeywords = newKeywords.replace(/(\[|\(|\")[\t ]+/g, '$1');
  // Remove extra spaces or tabs within compound keywords (ex: 'car insurance')
  newKeywords = newKeywords.replace(/\s+/g, ' ');

  let keywords = newKeywords.split(splitChar);

  if (isNegativeKeyword) {
    keywords = _.map(keywords, keyword => keyword.replace('%2C', ','));
  }

  return keywords;
};

const isKeywordsValid = (parsedKeywords, i18n) => {
  const keywords = parsedKeywords;

  if (!keywords.length > 0) {
    return {
      valid: false,
      error: [i18n.getString(_TL_('You haven\'t entered any keywords.'))],
    };
  }

  if (keywords.length > maxKeywords) {
    return {
      valid: false,
      error: [i18n.getString(_TL_('You can\'t add more than {0} keywords at a time.')).replace('{0}', maxKeywords)],
    };
  }

  const message = [];
  _.each(keywords, (keyword) => {
    let text = keyword;

    if (/^".*"$/.test(text)) {
      text = text.replace(/\"/g, '');
    } else if (/^\[.*\]$/.test(text)) {
      text = text.replace(/(\[|\])/g, '');
    } else if (/^\(.*\)$/.test(text)) {
      text = text.replace(/\(|\)/g, '');
    }

    if (_.size(text) > maxKeywordLength) {
      const truncatedKeyword = _.escape(`${text.substring(0, 100)}...`);
      const limitErrorMessage = i18n.getString(_TL_('Keyword cannot have more than {0} characters.')).replace('{0}', maxKeywordLength);
      message.push(i18n.getString(_TL_('{0}: {1}'))
        .replace('{0}', truncatedKeyword)
        .replace('{1}', limitErrorMessage));
    }
  });

  if (_.isArray(message) && _.size(message) > 0) {
    return {
      valid: false,
      error: message,
    };
  }

  return {
    valid: true,
    error: [],
  };
};

export const getUniqueParsedKeywords = (keywords) => {
  if (_.size(keywords) > 0) {
    return _.unique(keywords, false, keyword => keyword.toLowerCase());
    // DB's duplicate validation is case-insensitive
  }
  return [];
};

export const parseKeywords =
  ({
    keywordsTextarealVal,
    i18n,
    isNegativeKeyword = false,
    activity,
  }) => {
    const newKeywords = peekKeywords({ keywordsTextarealVal, isNegativeKeyword, activity });

    return {
      keywords: newKeywords,
      uniqKeywords: getUniqueParsedKeywords(newKeywords),
      validResult: isKeywordsValid(newKeywords, i18n),
    };
  };

export const parseKeyword = (text) => {
  let matchType = '';
  let keyword = text;

  if (/^".*"$/.test(text)) {
    keyword = text.replace(/\"/g, '');
    matchType = 'Phrase';
  } else if (/^\[.*\]$/.test(text)) {
    keyword = text.replace(/(\[|\])/g, '');
    matchType = 'Exact';
  } else {
    matchType = 'Broad';
  }

  return {
    Text: keyword,
    MatchType: matchType,
  };
};
